var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "subscription-premium-panel white-block" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "main-container" },
      [
        _c("SubscriptionActivityView", {
          on: { showPlan: _vm.showPlanSection },
        }),
        _vm._v(" "),
        _c("SubscriptionPassageView", {
          on: { showPlan: _vm.showPlanSection },
        }),
        _vm._v(" "),
        _c("SubscriptionCompetitionView", {
          on: { showPlan: _vm.showPlanSection },
        }),
        _vm._v(" "),
        _c("SubscriptionCuriculumView", {
          on: { showPlan: _vm.showPlanSection },
        }),
        _vm._v(" "),
        _c("SubscriptionSettingsView", {
          on: { showPlan: _vm.showPlanSection },
        }),
        _vm._v(" "),
        _c("SubscriptionPriorityView", {
          on: { showPlan: _vm.showPlanSection },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel-header" }, [
      _c("h3", { staticClass: "panel-title" }, [
        _vm._v("Get more power to deeply engage students in reading."),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "panel-description" }, [
        _vm._v("Explore the "),
        _c("a", [_vm._v("Premium")]),
        _vm._v(" ReadTheory Experience"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }